import { Badge } from '@pryme/ui';
import { pretty } from '../lib/files';
import { displayHeaders, type SignedTrace } from '../lib/signing';
import { CodeBlock } from './CodeBlock';

/** Full trace of a signed service → Pryme request and the verification of Pryme's response. */
export function TraceView(props: { trace: SignedTrace }) {
  const t = props.trace;
  const rs = t.responseSignature;
  return (
    <div>
      <div className="p-row" style={{ marginBottom: '0.75rem' }} role="status">
        <Badge tone={t.ok ? 'ok' : 'bad'}>HTTP {t.status}</Badge>
        {rs.present ? (
          <Badge tone={rs.valid ? 'ok' : 'bad'} icon={rs.valid ? 'check' : 'x'}>{rs.valid ? `Response signature valid (Pryme verification key ${rs.verifiedWithKid})` : 'Response signature invalid'}</Badge>
        ) : (
          <Badge tone={t.ok ? 'bad' : 'neutral'}>{t.ok ? 'Response unsigned: reject it' : 'Error responses are not signed'}</Badge>
        )}
      </div>
      <div className="p-grid">
        <div>
          <CodeBlock label="1. Canonical signature base (what your signing key signed)" code={t.base} />
          <CodeBlock label="2. Request headers" code={`${t.method} ${t.target}\n${displayHeaders(t.requestHeaders)}`} />
          <CodeBlock label="3. Request body (digest covers these exact bytes)" code={t.body || '(empty)'} />
        </div>
        <div>
          <CodeBlock label="4. Response body" code={pretty(t.responseJson)} maxHeight={360} />
          {rs.present && (
            <>
              <p className="dv-code-label" style={{ margin: '0 0 0.35rem' }}>5. Pryme response signature (pryme-response-signature)</p>
              <ul className="dv-check-list">
                {rs.checks.map((c) => (
                  <li key={c.label} className={c.ok ? 'ok' : 'bad'}>{c.label}{c.detail ? ` — ${c.detail}` : ''}</li>
                ))}
              </ul>
              {rs.decoded && <CodeBlock label="Decoded response-signature payload" code={pretty(rs.decoded)} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
